import { Alert, Group, Input, Modal, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { CopyToClipboard } from 'components/CopyToClipboard';
import { i18nKeys, useTranslation } from 'locales';

type SecretRevealModalProps = {
  opened: boolean;
  onClose: () => void;
  clientId: string | null;
  secret: string | null;
};

const boxStyle = {
  border: '1px solid var(--mantine-color-gray-3)',
  borderRadius: 'var(--mantine-radius-sm)',
};

// The rotated secret is shown here once and never again. Both credentials are
// laid out with distinct labels so the secret can't be mistaken for the (safe
// to share) client id.
export const SecretRevealModal = ({
  opened,
  onClose,
  clientId,
  secret,
}: SecretRevealModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      title={t(i18nKeys.SETTINGS.COMPANY.NEW_SECRET_ID)}
    >
      <Stack gap="md">
        <Alert variant="light" color="orange" icon={<IconAlertTriangle size={18} />}>
          {t(i18nKeys.SETTINGS.COMPANY.NOT_SHOW_SECRET_ID_ANYMORE)}
        </Alert>

        <Input.Wrapper label={t(i18nKeys.SETTINGS.CLIENT_ID)}>
          <Group
            gap="xs"
            wrap="nowrap"
            px="sm"
            py={6}
            bg="var(--mantine-color-gray-light)"
            style={boxStyle}
          >
            <Text size="sm" style={{ flexGrow: 1, wordBreak: 'break-all' }}>
              {clientId}
            </Text>
            {clientId != null && <CopyToClipboard text={clientId} />}
          </Group>
        </Input.Wrapper>

        <Input.Wrapper label={t(i18nKeys.SETTINGS.COMPANY.SECRET_ID)}>
          <Group
            gap="xs"
            wrap="nowrap"
            px="sm"
            py={6}
            bg="var(--mantine-color-gray-light)"
            style={boxStyle}
          >
            <Text size="sm" ff="monospace" fw={500} style={{ flexGrow: 1, wordBreak: 'break-all' }}>
              {secret}
            </Text>
            {secret != null && <CopyToClipboard text={secret} />}
          </Group>
        </Input.Wrapper>
      </Stack>
    </Modal>
  );
};
